import { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';

interface MemedSettingsCardProps {
  icon: LucideIcon;
  title: string;
  children: ReactNode;
}

export function MemedSettingsCard({ icon: Icon, title, children }: MemedSettingsCardProps) {
  return (
    <div className="rounded-xl bg-white border border-neutral-200 shadow-sm p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 bg-blue-100 rounded-lg">
          <Icon className="h-5 w-5 text-blue-600" />
        </div>
        <h3 className="font-semibold text-lg">{title}</h3>
      </div>
      {children}
    </div>
  );
}
